<template>

	<div class="q_pad_lr15px q_mar_t15px">
		<van-tabs @click="onClick"  swipe-threshold="1">
			<van-tab title="全部" name="1">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
					<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						error-text="请求失败，点击重新加载">
						<div class="q_vertical_left q_mar_b15px" style="width: 100%" @click="goToArtdea(item.id)"
							:key="item.id" v-for="item in list">
							<div class="q_inlineblock">
								<van-image class="q_act_img" fit="cover" :src="convertImg(item.pic)" />
							</div>
							<div class="q_mar_l15px q_inlineblock">
								<div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>
								<div class="q_text_s q_color_gray q_mar_t10px">{{item.createTime}}</div>
							</div>
						</div>

					</van-list>

				</van-pull-refresh>
				<!--空数据-->
				<div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
					<img src="@/assets/image/none.png" style="width: 26vw;" />
					<p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
				</div>
			</van-tab>
      <div v-for="item in articleTypeList">
			<van-tab :title="item.name" :name="item.id">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
					<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						error-text="请求失败，点击重新加载">
						<div class="q_vertical_left q_mar_b15px" style="width: 100%" @click="goToArtdea(item.id)"
							:key="item.id" v-for="item in list">
							<div class="q_inlineblock">
								<van-image class="q_act_img" fit="cover" :src="item.pic" />
							</div>
							<div class="q_mar_l15px q_inlineblock">
								<div class="q_text_m q_bold q_moit2 q_justify">{{ item.name }}</div>
								<div class="q_text_s q_color_gray q_mar_t10px">{{item.createTime}}</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
				<!--空数据-->
				<div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
					<img src="@/assets/image/none.png" style="width: 26vw;" />
					<p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
				</div>
			</van-tab>
    </div>
		</van-tabs>
	</div>
</template>

<script>
	import {
		listArticle,
		upArticleById
	} from "@/api/article";
  import {listArticleType} from "@/api/articleType";
  import {wxCloseShare} from "@/utils/jiutang";

	export default {
		name: 'Artlist',
		props: {
			msg: String
		},
		data() {
			return {
				showEmpty: false,
				refreshing: false,
				loading: false,
				finished: false,
				list: [],
				pageParam: {
					pageNum: 0,
					pageSize: 5,
					status: '0',
          articleTypeId:''
				},
        articleTypeList:[]
			}
		},
    created() {
      wxCloseShare()
      this.getArticleType()
    },
    methods: {
      /**
       * 获取一级分类菜单
       */
      getArticleType(){
        listArticleType().then((res)=>{
          this.articleTypeList = res.rows
        })
      },
			/**
			 * 下拉刷新
			 */
			onRefresh() {
        this.pageParam.pageNum = 0
        this.pageParam.pageSize = 5
        this.pageParam.status = '0'
				// 清空列表数据
				this.finished = false
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true
				this.onLoad()
			},
			/**
			 * 下滑加载更多
			 */
			onLoad() {
				this.pageParam.pageNum++
				if (this.pageParam.pageNum == 1) {
					this.$modal.loading()
				}
				//查询活动信息列表
				listArticle(this.pageParam).then(res => {
					if (res.total == 0) {
						this.showEmpty = true
					}else {
            this.showEmpty = false
          }
					//是否下拉刷新
					if (this.refreshing) {
						this.list = [];
						this.refreshing = false;
					}
					for (let i = 0; i < res.rows.length; i++) {
						this.list.push(res.rows[i]);
					}

					// 加载状态结束
					this.loading = false;

					// 数据全部加载完成
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				}).finally(() => {
					this.$modal.closeLoading()
				})
			},
			goToArtdea(id) {
				//增加动态点击数
				upArticleById(id).then(res => {
					this.$router.push({
						path: '/home/Artdea',
						query: {
							id: id
						}
					});
				})
			},
      /**
       * 分类点击事件
       */
      onClick(name, title) {
        //清空列表数据
        if (name == '1'){
          this.list = []
          this.pageParam.articleTypeId = ''
        }else {
          this.list = []
          //每次点击清空列表，重置查询条件
          this.pageParam.articleTypeId = name
        }
        this.onRefresh()

      },
		}
	}
</script>
<style scoped="scoped">
	>>> .van-tab--active {
		font-weight: 700;
		font-size: 16px;
	}

	>>> .van-tabs__line {
		background-color: #FF5733;
		height: 6px;
		border-radius: 3px;
		width: 30px;
	}

	>>> .van-tabs__content {
		margin-top: 50px;
	}

	>>> .van-tabs__wrap {
		position: fixed;
		top: 0;
		z-index: 1;
		width: calc(100% - 30px);
		padding-bottom: 6px;
	}
	.q_act_img {
		width: 110px;
		height: 62px !important;
	}

	.q_act_img >>> .van-image__img {
		border-radius: 5px;
	}

</style>
